import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { ClipboardSignature, Loader2 } from "lucide-react";
import { handoverApi } from "./handoverApi";

export const StartWalkthroughButton = ({ dwellingId, openWalkthroughId, size = "default", className = "", testId = "start-walkthrough-button" }) => {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const start = async () => {
    if (openWalkthroughId) return navigate(`/defects/walkthrough/${openWalkthroughId}`);
    setBusy(true);
    try {
      const wt = await handoverApi(`/dwellings/${dwellingId}/walkthroughs`, { method: "POST" });
      navigate(`/defects/walkthrough/${wt.id}`);
    } catch (e) {
      toast.error(e.message);
      if (/client/i.test(e.message)) navigate("/defects/client-walkthroughs");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button size={size} onClick={start} disabled={busy} data-testid={testId}
      className={`bg-indigo-600 hover:bg-indigo-700 text-white ${className}`}>
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ClipboardSignature className="w-4 h-4 mr-1.5" />}
      {openWalkthroughId ? "Continue Walkthrough" : "Start Client Walkthrough"}
    </Button>
  );
};
